/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
export enum PARAMS {
  ROOM_ID = 'roomId',
  BASE_JOURNAL_ENTRY_ID = 'baseJournalEntryId',
  SKIP_NETWORK_TEST = 'skipNetworkTest',
}

export const RouterStates = {
  ROOM: `/rooms/:${PARAMS.ROOM_ID}`,
  NOTARY_ROOM: `/notary/rooms/:${PARAMS.ROOM_ID}([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})`,
  PARTICIPANT_SIGNING_ROOM: `/rooms/:${PARAMS.ROOM_ID}/signing`,
  NOTARY_SIGNING_ROOM: `/notary/rooms/:${PARAMS.ROOM_ID}/signing`,
  DOCUMENT_MANAGEMENT: `/notary/rooms/:${PARAMS.ROOM_ID}/documents/manage`,
  PARTICIPANT_ROOM_EARLY: `/rooms/:${PARAMS.ROOM_ID}/early`,
  PARTICIPANT_ROOM_NOT_SCHEDULED: `/rooms/:${PARAMS.ROOM_ID}/not-scheduled`,
  PARTICIPANT_ROOM_FINISH: `/rooms/:${PARAMS.ROOM_ID}/finish`,
  NOTARY_ROOM_FINISH: `/notary/rooms/:${PARAMS.ROOM_ID}/finish`,
  ROOM_EXIT: `/rooms/:${PARAMS.ROOM_ID}/exit`,
  JOURNAL: `/notary/journal`,
  JOURNAL_ENTRY: `/notary/journal/:${PARAMS.BASE_JOURNAL_ENTRY_ID}`,
  ROOMS: `/notary/rooms`,
  ROOM_ASSIGNMENTS: `/notary/rooms/assignments`,
  INVITE: `/notary/invite`,
  NOTARY: '/notary',
  DEVICE_TESTING: `/rooms/:${PARAMS.ROOM_ID}/device-testing`,
} as const;
